import {
  type LinkProps,
  Link as SapphireLink,
  tokens,
} from '@sapphire-react/core';

export function Link({ children, ...rest }: LinkProps) {
  return (
    <SapphireLink
      UNSAFE_style={{
        textDecoration: 'underline',
        color: tokens.color.foregroundActionLinkDefault.value,
      }}
      {...rest}
    >
      {children}
    </SapphireLink>
  );
}
